/* eslint-disable @typescript-eslint/no-use-before-define */

import {
  Input,
  Component,
  forwardRef,
  HostListener,
  ViewChild,
  ElementRef,
  OnInit,
  Output,
  EventEmitter,
  OnChanges,
} from "@angular/core";
import { EInputStyleType } from "../../../data-types/input-style.enum";
import { iconsLibrary } from "../../../../theme/constants";
import * as moment from "moment";
@Component({
  selector: "cowing-datepicker",
  templateUrl: "./cowing-datepicker.component.html",
  styleUrls: ["./cowing-datepicker.component.scss"],
})
export class CowingDatepickerComponent implements OnInit {
  @HostListener("document:click", ["$event"])
  onClick(event) {}

  @Output("click") clicked = new EventEmitter();

  @Input("value") value: any = null;
  @Input("inputStyle") inputStyle: string = EInputStyleType.Primary;
  @Input("disabled") disabled: boolean = false;

  constructor() {}
  ngOnInit() {}

  public onInputChange(event?: any) {
    if (event) {
      this.clicked.emit(event);
    }
  }
}
